module.exports = __webpack_public_path__ + "static/camera@2x-1cd1aa04259b249aac5b9558ed2a8578.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/wireframing/camera@2x.png
// module id = 2621
// module chunks = 168707334958949